module.exports = __webpack_public_path__ + "img/02-trpg-material2021.7484da1b.png";